import config from '../config';
import { chatActions, consultationActions } from '../_actions';
import { store } from './';


export let socket = null;

export const openWSConnection = () => {
    if (!socket && localStorage.getItem(config.accessTokenName)) {
        socket = new WebSocket(config.wsBaseUrl + '/' + localStorage.getItem(config.accessTokenName));
        socket.onmessage = handleSocketMessage;
        socket.onclose = () => {
            socket = null;
            // setTimeout(() => {
                openWSConnection();
            // }, 5000);
        };
    }
};

const handleSocketMessage = msg => {
    const data = JSON.parse(msg.data);

    if (data.event === 'chatMessage') {
        store.dispatch(chatActions.addMessage(data.message));
    } else if (data.event === 'callFinished') {
        //sent when a consultation is closed; the screens poll as well, this just makes it immediate
        store.dispatch(consultationActions.setCallFinished(data.message));
    }
};
